import React, { ComponentType } from 'react';
import { Params, useParams } from 'react-router-dom';

interface WithRouterProps {
  params: Params;
}

export default function withRouter<T>(
  Component: ComponentType<T & WithRouterProps>,
) {
  return (props: T) => {
    const params = useParams<Params>();

    return <Component {...props} params={params} />;
  };
}
